import React, { useState } from 'react';
import { ShieldOff, ShieldCheck, Flag } from 'lucide-react';
import { Button } from './ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';
import ReportDialog from './ReportDialog';
import { apiClient } from '../api';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const SafetyMenu = ({ targetUserId, targetName }) => {
  const [confirmBlock, setConfirmBlock] = useState(false);
  const navigate = useNavigate();

  const doBlock = async () => {
    try {
      await apiClient.post(`/blocks/${targetUserId}`);
      toast.success(`${targetName || 'User'} blocked`, {
        description: 'They can no longer see or message you.',
      });
      navigate('/browse');
    } catch (err) {
      toast.error('Could not block', { description: err.response?.data?.detail || '' });
    } finally {
      setConfirmBlock(false);
    }
  };

  return (
    <div className="flex items-center gap-1.5">
      <ReportDialog
        targetUserId={targetUserId}
        targetName={targetName}
        trigger={
          <Button
            variant="ghost"
            className="text-purple-300 hover:text-red-300 hover:bg-white/5 h-9 px-3"
            data-testid="safety-report-btn"
          >
            <Flag className="w-4 h-4 mr-1.5" />Report
          </Button>
        }
      />
      <Button
        variant="ghost"
        onClick={() => setConfirmBlock(true)}
        className="text-purple-300 hover:text-red-300 hover:bg-white/5 h-9 px-3"
        data-testid="safety-block-btn"
      >
        <ShieldOff className="w-4 h-4 mr-1.5" />Block
      </Button>

      <AlertDialog open={confirmBlock} onOpenChange={setConfirmBlock}>
        <AlertDialogContent className="bg-fnl-purple border-purple-900 text-white" data-testid="block-confirm">
          <AlertDialogHeader>
            <AlertDialogTitle className="flex items-center gap-2 text-white">
              <ShieldCheck className="w-5 h-5 text-red-400" />Block {targetName || 'this user'}?
            </AlertDialogTitle>
            <AlertDialogDescription className="text-purple-200">
              They won't be able to see your profile or message you. You won't see them in browse or views either. You can unblock from{' '}
              <span className="text-white font-semibold">Account → Blocked users</span>.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-fnl-purple-light/40 border-purple-700 text-white">Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={doBlock}
              className="bg-red-500 hover:bg-red-600 text-white"
              data-testid="block-confirm-btn"
            >
              Yes, block them
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default SafetyMenu;
